
import { obtenerNumeroLog, obtenIP, registraLog } from "../../api/logs";
import { obtenerUsuario } from "../../api/usuarios";
import { getTokenApi, logoutApi, obtenidusuarioLogueado } from "../../api/auth";

export function LogsInformativos(mensaje, datos){
    try {
        obtenerUsuario(obtenidusuarioLogueado(getTokenApi())).then(response =>
        {
            const { data: { nombre, email } } = response;
            obtenIP().then(response => {
                const { data } = response;
                const IpTemp = data;

                // Obten el numero de log que corresponda
                obtenerNumeroLog().then(response => {
                    const { data: { noLog } } = response;

                    // Verifica si se reciben datos de información extra en los parametros
                    if(datos){
                        const dataTemp = {
                            folio: noLog,
                            usuario: nombre,
                            correo: email,
                            dispositivo: navigator.platform,
                            ip: IpTemp,
                            descripcion: navigator.userAgent,
                            detalles: {
                                mensaje: mensaje,
                                datos: datos
                            }
                        }

                        registraLog(dataTemp).then(response => {
                            const { data } = response;
                            //console.log(data)
                        }).catch(e => {
                            console.log(e)
                            console.log(e.response)
                        })
                    } else {
                        //
                        const dataTemp = {
                            folio: noLog,
                            usuario: nombre,
                            correo: email,
                            dispositivo: navigator.platform,
                            ip: IpTemp,
                            descripcion: navigator.userAgent,
                            detalles: {
                                mensaje: mensaje
                            }
                        }

                        registraLog(dataTemp).then(response => {
                            const { data } = response;
                            //console.log(data)
                        }).catch(e => {
                            console.log(e)
                            console.log(e.response)
                        })
                    }

                }).catch(e => {
                    console.log(e)
                })

            }).catch(e => {
                console.log(e)
            })
        })
    } catch (e) {
        //
    }
}

export function LogsInformativosLogout(mensaje){
    try {
        obtenerUsuario(obtenidusuarioLogueado(getTokenApi())).then(response =>
        {
            const { data: { nombre, email } } = response;
            obtenIP().then(response => {
                const { data } = response;
                const IpTemp = data;

                // Obten el numero de log que corresponda
                obtenerNumeroLog().then(response => {
                    const { data: { noLog } } = response;

                    const dataTemp = {
                        folio: noLog,
                        usuario: nombre,
                        correo: email,
                        dispositivo: navigator.platform,
                        ip: IpTemp,
                        descripcion: navigator.userAgent,
                        detalles: {
                            mensaje: mensaje
                        }
                    }

                    registraLog(dataTemp).then(response => {
                        const { data } = response;
                        //console.log(data)
                        logoutApi();
                    }).catch(e => {
                        console.log(e)
                        console.log(e.response)
                    })

                }).catch(e => {
                    console.log(e)
                })

            }).catch(e => {
                console.log(e)
            })
        })
    } catch (e) {
        //
    }
}
